









export default {
  components: {},
  name: 'SkeletonWrapper',
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
};
